const sendPQRS = async (formData) => {
  const data = new FormData();

  data.append("name", formData.name);
  data.append("phone", formData.phone);
  data.append("email", formData.email);
  data.append("type", formData.type);
  data.append("message", formData.message);

  if (formData.file) {
    data.append("file", formData.file);
  }

      // Si es local
  //  const response = await fetch(
  //     "http://localhost/websitegsa/server/api/send-pqrs.php",
  //     {
  //       method: "POST",
  //       body: data,
  //     }
  //   );

    // PARA EL SERVIDOR
  const response = await fetch(
    "/server/api/send-pqrs.php",
    {
      method: "POST",
      body: data,
    }
  );

  let result;

  try {
    result = await response.json();
  } catch (error) {
    throw new Error(
      "El servidor devolvió una respuesta no válida."
    );
  }

  if (!response.ok || !result.success) {
    throw new Error(
      result.message ||
      "No fue posible enviar la PQRS."
    );
  }

  return result;
};

export {
  sendPQRS,
};